import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react'
import checkIcon from "./img/check.png";
import "./styles/MultiSelectOptions.scss";
import { FormattedMessage, useIntl } from 'react-intl';

const MultiSelectOptions = ({ 
  selectValues,
  selectedOptions,
  loading,
  disabledPlaceholder,
  handleClickCurrentOption,
  onFilterChange
}) => {
  const intl = useIntl();
  const searchInputRef = useRef(null);
  const [listValues, setListValues] = useState(selectValues);
  const debounceTimeout = useRef(null);

  const handlerDebounceToFilter = (callback, delay) => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      callback();
    }, delay);
  };

  const handleProductFilter = (e) => {
    const filterValue = e.target.value.toLowerCase();
    handlerDebounceToFilter(() => onFilterChange(filterValue), 1000)
  };

  useEffect(() => {
    setListValues(selectValues);
  }, [selectValues]);

  useEffect(() => {
    searchInputRef.current.focus(); /* Auto focus search input */
  }, [])

  return (
    <div className="multi-options bg-white p-3 mt-1">
      <input
        ref={searchInputRef}
        className="multi-options__search col-12 mb-2 px-1 border-top-0 border-left-0 border-right-0 border-bottom"
        type="text"
        alt="filter-search"
        placeholder={intl.formatMessage({ id: "ProductsMultiSelect.search" })}
        onChange={handleProductFilter}
      />
      {!loading ? (
        listValues?.map(({ id, label, value }, index) => (
          <div
            key={id}
            className={classNames({
              "select__current-option d-flex align-items-center": true,
              "select__current-option-with-border":
                index !== listValues.length - 1,
            })}
            onClick={handleClickCurrentOption({ label, value })}
          >
            <span
              className={classNames({
                "check-option border border-dark rounded-circle d-flex align-items-center justify-content-center p-2 mr-1": true,
                "check-option-selected": selectedOptions &&selectedOptions?.some(
                  (option) => option.label?.toLowerCase().trim() === label.toLowerCase().trim()
                ),
              })}
              onClick={handleClickCurrentOption({ label, value })}
            >
              <img src={checkIcon} alt="check-icon" width={10} height={10} />
            </span>
            <span dangerouslySetInnerHTML={{ __html: label }} />
          </div>
        ))
      ) : disabledPlaceholder}
    </div>
  );
}

export default MultiSelectOptions;
